import { Component, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiOfferSet } from '../../api';

@Component({
  selector: 'tyt-donations-goals',
  templateUrl: './donations-goals.component.html',
  styleUrls: ['./donations-goals.component.scss']
})
export class DonationsGoalsComponent {
  constructor(
    private activatedRoute: ActivatedRoute
  ) { }

  @Input() offerSet: ApiOfferSet;
  @Input() period: string;
  currentPeriod: string;

  mode: 'membership' | 'contribution';

  // TODO: We need to duplicate the period selection logic here because we don't have a clear path
  // to send the current period from the pricing step to this component. Ideally we should make a
  // way for that to happen instead of duplicating it here.

  periodLabels: Record<string, string> = {
    one_time: 'One Time',
    monthly: 'Monthly',
    annually: 'Annually'
  };

  ngOnInit() {
    const currentPeriod = this.period ?? this.offerSet?.default_period;
    this.determinePage(currentPeriod);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.period) {
      this.determinePage(changes.period.currentValue);
      this.currentPeriod = changes.period.currentValue;
    }
    if (changes.offerSet && changes.offerSet.currentValue) {
      this.currentPeriod = this.offerSet.default_period ?? this.period;
    }
  }

  private determinePage(period: string) {
    if (!period || !this.periodLabels[period]) {
      console.warn(`Invalid period: ${period}. Defaulting to 'monthly'.`);
      period = 'monthly';
    }
    this.mode = period === 'one_time' ? 'contribution' : 'membership';
  }
  
}
